<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <ng-container>
      <div class="icon" inlineSVG="sot/sot-icon.svg#sot-qrscan-ani" [setSVGAttributes]="{class: 'box-icon'}"></div>
    </ng-container>
    <h1 [langkey]="titleKey"></h1>
  </header>
  <sot-numberPad #numberPad [requiredLength]="requiredVoucherLength" [hideInput]="true"></sot-numberPad>
  <footer class="buttons">
    <a class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </a>
    <a [class.disabled]="submitDisabled" (click)="submit()" class="btn goforward">
      <span langkey="button_continue"></span>
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </a>
  </footer>
</div>